/**
 * Tiny dev-only logger.
 *
 * Production builds (CRA / Vite / Next set NODE_ENV='production' at build
 * time) become no-ops thanks to dead-code-elimination, so these calls
 * leave zero footprint in the shipped bundle. In dev mode they forward to
 * the browser console so you keep your normal debugging workflow.
 *
 * Usage: replace ad-hoc `console.error(...)` in .catch() handlers with
 * `devError(...)` — sensitive payloads never leak to end-users' console.
 */
const isDev = process.env.NODE_ENV !== "production";

export const devError = (...args) => {
  if (isDev) console.error(...args);
};

export const devWarn = (...args) => {
  if (isDev) console.warn(...args);
};

export const devLog = (...args) => {
  if (isDev) console.log(...args);
};
